var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 48,
    viewBox: "0 0 55 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.4602 47.56C44.6662 47.56 54.6127 37.6357 54.6127 25.4075C54.6127 13.2015 44.6662 3.255 32.4602 3.255C20.232 3.255 10.3077 13.2015 10.3077 25.4075C10.3077 37.4285 19.8984 47.223 31.8404 47.5515L32.4602 47.56Z",
    fill: "url(#paint0_linear)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0396 15.777C28.2822 15.777 25.2433 18.8159 25.2433 22.5732C25.2433 24.2626 25.7288 25.8451 26.6123 27.2724C27.5347 28.7675 28.7483 30.0491 29.6803 31.5443C30.1366 32.2725 30.4668 32.9521 30.8163 33.7385C31.0687 34.2725 31.2726 35.1948 32.0396 35.1948C32.8066 35.1948 33.0105 34.2725 33.2532 33.7385C33.6124 32.9521 33.9328 32.2725 34.3892 31.5443C35.3212 30.0588 36.5348 28.7772 37.4572 27.2724C38.3504 25.8451 38.8359 24.2626 38.8359 22.5732C38.8359 18.8159 35.797 15.777 32.0396 15.777ZM32.0396 25.2432C30.6998 25.2432 29.6124 24.1558 29.6124 22.816C29.6124 21.4761 30.6998 20.3887 32.0396 20.3887C33.3794 20.3887 34.4668 21.4761 34.4668 22.816C34.4668 24.1558 33.3794 25.2432 32.0396 25.2432Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b",
    x: -2.71258,
    y: -9.76525,
    width: 70.3456,
    height: 70.3456,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 6.51013
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: -13.9999,
    y1: 47.9999,
    x2: 73.5001,
    y2: 136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7B0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B5DFE",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation3);
export default __webpack_public_path__ + "static/media/location3.9afb60f2452b4dd2866071e2f17cd81e.svg";
export { ForwardRef as ReactComponent };